<template>
  <div :class="{ 'show-date-time': ShowCalendar }">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <div>
            <label for="note" class="form-label">{{ "Note *" }}</label>
            <textarea
              class="form-control"
              name="note"
              :placeholder="'Note'"
              rows="5"
              v-model="model.notes"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <div class="custom-dropdown-chip">
            <label for="Status" class="form-label">{{ "Status *" }}</label>
            <b-nav-item-dropdown
              right
              no-caret
              variant="black"
              class="dropdown d-none d-lg-block mr-0 custom-dropdown-chip"
            >
              <template v-slot:button-content>
                <div
                  ref="statusDropdown"
                  class="custom-select-chip"
                  @click="onShowStatusList"
                >
                  <button
                    class="custom-chip"
                    :class="`chip-status${model.status.value}`"
                  >
                    {{ model.status.text }}
                  </button>
                  <i
                    class="uil uil-angle-down my-auto"
                    style="font-size: 20px"
                  ></i>
                </div>
              </template>
              <button
                class="custom-chip mb-3"
                :class="`chip-status${status.value} ${showStatus || 'hide'}`"
                style="display: block"
                v-for="(status, idx) in statusOptions"
                :key="idx"
                @click="onInputStatus(status)"
              >
                {{ status.text }}
              </button>
            </b-nav-item-dropdown>
          </div>
        </div>
      </div>

      <!-- <div v-if="!model.add_interview && isShowAddInterview && this.model.status.value == 4 && !isInterviewAdded" class="form-group col-md-5 pt-2 my-auto">
        <button 
          class="btn2 btn2-secondary"
          @click="onAddInterview"
        >
          <i class="uil uil-plus" style="font-size: 10px;"></i>
          Additional Interview
        </button>
      </div> -->
      <div class="col-md-6" v-if="model.status.value != 4">
        <div class="form-group">
          <div class="custom-dropdown-chip">
            <label class="form-label">{{ "Substatus*" }}</label>
            <b-nav-item-dropdown
              right
              no-caret
              variant="black"
              class="dropdown d-none d-lg-block mr-0 custom-dropdown-chip"
            >
              <template v-slot:button-content>
                <div
                  ref="subStatusDropdown"
                  class="custom-select-chip"
                  @click="onShowSubStatusList"
                >
                  <button
                    v-if="model.sub_status && model.sub_status.text"
                    class="custom-chip"
                    :class="`chip-status${model.status.value}`"
                  >
                    {{ model.sub_status.text }}
                  </button>
                  <button v-else class="btn2 btn2-tertiary my-1">
                    Select a Substatus
                  </button>
                  <i
                    class="uil uil-angle-down my-auto"
                    style="font-size: 20px"
                  ></i>
                </div>
              </template>
              <button
                class="custom-chip mb-3"
                :class="`chip-status${status.status_id} ${
                  showSubStatus || 'hide'
                }`"
                style="display: block"
                v-for="(status, idx) in subStatusOptions"
                :key="idx"
                @click="onInputSubStatus(status)"
              >
                {{ status.text }}
              </button>
            </b-nav-item-dropdown>
          </div>
        </div>
      </div>

      <div class="col-md-12" />
      <div class="col-md-6">
        <div class="form-group">
          <div class="custom-dropdown-chip">
            <label class="form-label">{{ "Assign To" }}</label>
            <b-nav-item-dropdown
              right
              no-caret
              variant="black"
              class="dropdown d-none d-lg-block mr-0 custom-dropdown-chip chip-assign-to"
            >
              <template v-slot:button-content>
                <div class="custom-select-chip chip-assign-to">
                  <button class="btn2 btn2-tertiary my-1">
                    {{
                      model.assign_to && model.assign_to.full_name
                        ? model.assign_to.full_name
                        : "Select a user"
                    }}
                  </button>
                  <i
                    class="uil uil-angle-down my-auto"
                    style="font-size: 20px"
                  ></i>
                </div>
              </template>
              <b-dropdown-item
                href="javascript:void(0);"
                class="notify-item"
                v-for="(item, idx) in assignToOptions"
                :key="idx"
                @click="onInputAssignTo(item)"
              >
                {{ item.full_name }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
        </div>
      </div>

      <div class="col-md-6" v-if="showExams">
        <div class="form-group">
          <div class="custom-dropdown-chip">
            <label class="form-label">{{ "Exams" }}</label>
            <b-nav-item-dropdown
              right
              no-caret
              variant="black"
              class="dropdown d-none d-lg-block mr-0 custom-dropdown-chip chip-assign-to"
            >
              <template v-slot:button-content>
                <div class="custom-select-chip chip-assign-to">
                  <button class="btn2 btn2-tertiary my-1">
                    {{
                      model.assign_exam && model.assign_exam.title
                        ? model.assign_exam.title
                        : "Select a exam"
                    }}
                  </button>
                  <i
                    class="uil uil-angle-down my-auto"
                    style="font-size: 20px"
                  ></i>
                </div>
              </template>
              <b-dropdown-item
                href="javascript:void(0);"
                class="notify-item"
                v-for="(item, idx) in examOptions"
                :key="idx"
                @click="onAssignExam(item)"
              >
                {{ item.title }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
        </div>
      </div>
      <!-- Add Meeting Type (Select Option) and Meeting Link inputs -->
      <div
        class="col-md-6"
         v-if="[6, 8, 9, 10].includes(model.sub_status.value)"
      >
        <div class="form-group">
          <label for="meetingType" class="form-label">{{
            "Meeting Type *"
          }}</label>
          <select class="form-control" v-model="model.meetingType">
            <option value="" disabled>Select Meeting Type</option>
            <option value="gmeet">Google Meet</option>
            <option value="zoom">Zoom Meeting</option>
          </select>
        </div>
      </div>

      <div
        class="col-md-12"
         v-if="[6, 8, 9, 10].includes(model.sub_status.value)"
      >
        <div class="form-group">
          <label for="meetingLink" class="form-label">{{
            "Meeting Link *"
          }}</label>
          <input
            type="text"
            class="form-control"
            v-model="model.meetingLink"
            placeholder="Enter meeting link"
          />
        </div>
      </div>

      <div class="col-md-12" v-if="showDate">
        <div class="form-group">
          <div>
            <label class="form-label">{{ "Date & Time *" }}</label>
            <input
              type="text"
              readonly=""
              class="form-control"
              v-model="computedDateTime"
              @click="ShowCalendar = !ShowCalendar"
            />
          </div>
        </div>
      </div>

      <div
        class="col-md-9 pb-1"
        style="background-color: white"
        v-show="ShowCalendar && showDate"
      >
        <div class="form-group custom-date-time">
          <flat-pickr
            v-model="model.date"
            class="custom-pickr mt-1"
            :config="dateTimePicker"
          />

          <label class="form-label mb-0 ml-5" style="float: left">{{
            "Start Time"
          }}</label>
          <flat-pickr
            v-model="model.start_time"
            class="custom-pickr"
            :config="{
              inline: true,
              shorthandCurrentMonth: true,
              enableTime: true,
              dateFormat: 'h:i K',
              noCalendar: true,
            }"
          />

          <label class="form-label mb-0 ml-5" style="float: left">{{
            "End Time"
          }}</label>
          <flat-pickr
            v-model="model.end_time"
            class="custom-pickr"
            :config="{
              inline: true,
              shorthandCurrentMonth: true,
              enableTime: true,
              dateFormat: 'h:i K',
              noCalendar: true,
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import Dropdown from "@src/static/dropdown";

export default {
  props: {
    parameters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        status: { value: 1, text: "Shortlisted" },
        assign_to: { value: 1, text: "HR" },
        assign_exam: {},
        // sub_status: {value: 1, text: 'Text'}
        meetingType: "",
        meetingLink: "",
      },
      dateTimePicker: {
        dateFormat: "d-m-Y",
        inline: true,
        shorthandCurrentMonth: true,
        locale: {
          weekdays: {
            shorthand: ["S", "M", "T", "W", "T", "F", "S"],
            longhand: [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ],
          },
        },
      },
      assignToOptions: [],
      subStatusOptions: [],
      statusOptions: [
        // {value: 1, text: 'Shortlisted'},
        // {value: 2, text: 'Submitted'},
        // {value: 3, text: '1st Interview'},
        // {value: 4, text: '2nd Interview'},
        // {value: 6, text: 'Offered'},
        // {value: 7, text: 'Placed'},
        // {value: 8, text: 'Rejected'},
        ...Dropdown.statusList,
      ],
      addOptions: [
        { value: 1, text: "Shortlisted" },
        { value: 2, text: "Submitted" },
        { value: 5, text: "Additional Interview" },
        { value: 6, text: "Offered" },
        { value: 7, text: "Placed" },
        { value: 8, text: "Rejected" },
      ],
      showDate: false,
      ShowCalendar: false,
      showStatus: false,
      showSubStatus: false,
      isInterviewAdded: false,
      currentStatus: "",
      isShowAddInterview: false,
      subStatus: "",
      showExams: false,
      examOptions: [],
    };
  },
  computed: {
    computedDateTime() {
      let { date, start_time, end_time } = this.model;
      return `${date || ""} ${start_time || ""}${
        start_time && end_time ? " - " : ""
      }${end_time || ""}`;
    },
  },
  filters: {
    date: function (value, format) {
      return moment(value).format(format || "YYYY-MM-DD");
    },
    custom_date: function (value) {
      return moment(value).format("Mo MMMM YYYY");
    },
  },
  methods: {
    onShowStatusList() {
      if (!this.showStatus) {
        this.$refs.statusDropdown.click();
      }
      this.showStatus = true;
    },
    onShowSubStatusList() {
      if (!this.showSubStatus) {
        this.$refs.subStatusDropdown.click();
      }
      this.showSubStatus = true;
    },
    onInputStatus(val, sub_status_type) {
      this.fetchSubStatus({ ...val }, sub_status_type);
      this.model.status = val;
      val = parseInt(val.value);
      // this.showDate = (val >= 3 && val <= 5) ? true : false
      this.showStatus = false;
      
      // this.model.add_interview = val == 5 ? true : false
      // this.model.rejected = val == 8 ? true : false
      

      if (!this.showDate) {
        this.model = {
          ...this.model,
          status: this.model.status,
          notes: this.model.notes || "",
          rejected: this.model.rejected,
        };
      }
    },
    onInputAssignTo(val) {
      this.model.assign_to = val;
    },
    onAssignExam(val) {
      this.model.assign_exam = val;
    },
    onInputSubStatus(val) {
      this.model.sub_status = {};
      this.model.sub_status = val;
      // this.subStatus = val.text

      val = parseInt(val.value);
      this.showDate = val >= 4 && val <= 10 ? true : false;

      this.model.add_interview = val == 10 ? true : false;
      this.model.rejected = val == 12 || val == 15 ? true : false;

      this.showExams = val == 4 ? true : false;
      this.showSubStatus = false;

      if (!this.showExams) this.model.assign_exam = {};
    },
    fetchData() {
      let param = {};
      param.id = this.parameters.applicationID;

      return this.$store
        .dispatch("application/getApplication", param)
        .then(async (res) => {
          if (res && res.data) {
            let { status_type, sub_status_type, date_interview, assign_to, meetingType, meetingLink } =
              res.data;
            // let status_value = activities.length && activities[0].rejected ? 8 : status_type == 5 ? 4 : status_type
            let status = this.statusOptions.filter((el) => {
              return el.value == status_type;
            });
            this.onInputStatus({ ...status[0] }, sub_status_type);

            this.onInputAssignTo({ ...assign_to });
            this.model.dateTime = date_interview;

            // this.isShowAddInterview = status_value == 4
            this.currentStatus = status_type;
            this.model.meetingType = meetingType;
            this.model.meetingLink = meetingLink;
          }
        });
    },
    fetchUser() {
      let param = {};
      param._atv = "activated";
      return this.$store.dispatch("user/pagination", param).then((res) => {
        if (res && res.data) {
          this.assignToOptions = res.data.data;
        }
      });
    },
    fetchSubStatus(status, sub_status_type) {
      this.subStatusOptions = [];
      let list = Dropdown.subStatusList.filter(
        (val) => val.status_id == status.value
      );
      this.subStatusOptions = [...list];
      let sub_status = this.subStatusOptions || [];
      if (sub_status_type) {
        sub_status = this.subStatusOptions.filter((el) => {
          return el.value == sub_status_type;
        });
      }
      console.log("sub_status", sub_status);
      this.onInputSubStatus({ ...sub_status[0] });
    },
    onAddInterview() {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to add interview?", {
          title: "Please Confirm Action",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((res) => {
          if (res == true) {
            this.statusOptions.map((res) => {
              if (res.value == 4) {
                this.statusOptions = this.addOptions;
                let status = this.addOptions.filter((res) => res.value == 5);
                this.onInputStatus({ ...status[0] });
                this.isInterviewAdded = true;
                this.model.add_interview = true;
                // this.statusOptions.splice(2, 2)
              }
              return res;
            });
          }
        });
    },
    fetchExams() {
      return this.$store.dispatch("exam/all").then((res) => {
        if (res && res.data) {
          this.examOptions = res.data.data;
        }
      });
    },
  },
  mounted() {
    if (this.parameters.applicationID) {
      this.fetchUser();
      this.fetchData();
      this.fetchExams();
    }
  },
};
</script>

<style lang="scss">
.custom-date-time {
  text-align: center;
  box-shadow: 0px 1px 5px rgba(3, 0, 19, 0.5) !important;
  padding: 1px !important;
  // border: 1px solid rgba(3, 0, 19, 0.5);
  // border-radius: 0.3rem;

  .flatpickr-calendar {
    padding: 0px 19px 19px 19px;
    width: 368px;
    margin-left: auto;
    margin-right: auto;
    // margin-top: 5px;
    // box-shadow: 0px 1px 5px rgba(3, 0, 19, 0.5) !important;
    border-radius: 5px;
    border: none !important;

    .flatpickr-innerContainer {
      padding: 10px;
    }
    .flatpickr-weekdays {
      background: #ffffff !important;
      font-size: 12px;
      .flatpickr-weekday {
        color: rgba(0, 0, 0, 0.38) !important;
      }
    }

    .flatpickr-time {
      padding: 0 30px;
    }
    .flatpickr-weekdays,
    .dayContainer {
      padding: 15px;
    }

    .dayContainer {
      .selected:hover,
      .selected {
        background: #eb2f5b !important;
      }
    }

    .flatpickr-time {
      margin-top: 5px;
    }

    .flatpickr-day {
      font-size: 12px;
    }
    .flatpickr-time,
    .flatpickr-innerContainer {
      box-shadow: 0px 1px 5px rgba(3, 0, 19, 0.5) !important;
      border-radius: 5px;
    }
  }
}

.custom-datetime-pick {
  position: absolute;
  z-index: 2;
  background-color: white;
  top: 100%;
  box-shadow: 0px 2px 10px rgba(3, 0, 19, 0.5);
  border-radius: 0 0 20px 15px;
}

.custom-select-chip {
  margin: auto;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e2e7f1;
  border-radius: 0.3rem;
  box-sizing: border-box;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
}

.custom-dropdown-chip .nav-link {
  padding: 0px !important;
}
.dropdown-menu.show:has(> .custom-chip) {
  margin-top: 5px;
  width: 100%;
  padding-left: 10px;
  background: #ffffff;
  border: 1px solid #e2e7f1;
  border-radius: 10px;
}

.dropdown-menu.show:has(> .custom-chip.hide) {
  display: none;
}

.custom-pickr {
  display: none;
}
.custom-date-field {
  height: 40px;
}

.chip-assign-to {
  .dropdown-menu.show {
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>
